import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { ReportPDF } from "../utils/reportPDF";

const DownloadReportButton = ({
  data,
  restaurantName,
  date,
}) => {

  console.log("pdf", data)
  return (
    <div className="flex items-center gap-3">

      <PDFDownloadLink
        document={
          <ReportPDF
            data={data}
            restaurantName={restaurantName}
            date={date}
          />
        }
        fileName={`${restaurantName}-report.pdf`}
        className="no-underline"
      >
        {({ loading }) => (
          <button
            disabled={loading}
            className={`
              flex items-center gap-2 px-5 py-2.5 rounded-lg
              text-white font-medium transition-all duration-200
              shadow-md
              ${loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-gradient-to-r from-indigo-500 to-purple-600 hover:scale-[1.02] hover:shadow-lg"
              }
            `}
          >
            {loading ? (
              <>
                <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
                Generating...
              </>
            ) : (
              <>
                📄 Download Report
              </>
            )}
          </button>
        )}
      </PDFDownloadLink>

    </div>
  );
};

export default DownloadReportButton;